import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ppaUrls } from 'config/urls';
import {
    adaptPerformanceSummaryMeta,
    type AdaptedFeature,
    type AdaptedPerformanceSummaryMeta,
    type UnifiedMetaNode,
} from './adaptPerformanceSummaryMeta';

type UnifiedPerformanceSummaryMetaResponse = {
    root: UnifiedMetaNode;
};

const usePerformanceSummaryMeta = () => {
    const { data: performanceSummaryMeta, isLoading, isPending } = useQuery<AdaptedPerformanceSummaryMeta>({
        queryKey: ['performance-summary-meta'],
        queryFn: async () => {
            const response = await axios.get<UnifiedPerformanceSummaryMetaResponse>(ppaUrls.getPerformanceSummaryMetaUrl);
            return adaptPerformanceSummaryMeta(response.data.root);
        },
    });

    return { performanceSummaryMeta, isLoading, isPending };
};

export type { AdaptedFeature as PerformanceFeature, AdaptedPerformanceSummaryMeta as PerformanceSummaryMetaResponse };
export default usePerformanceSummaryMeta;
